import React from 'react';
import TpClientPaymentTpClientInvoiceSearchParams from './TpClientPaymentTpClientInvoiceSearchParams';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import AppliedTpClientInvoiceItem from '../../../Domain/AppliedTpClientInvoiceItem';
import ApplyTpPaymentItem from '../../../Domain/ApplyTpPaymentItem';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';

export default class AppliedTpClientInvoiceAdmin extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
    isReport: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new TpClientPaymentTpClientInvoiceSearchParams(props.tpClientPaymentId, 'applied', 'applied_tp'),
      shownPanel: ShownPanelsEnum.None,
    };

    this.refresh = this.refresh.bind(this);
    this.removePaymentFunction = this.removePaymentFunction.bind(this);
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  removePaymentFunction() {
    const selectedItem = new ApplyTpPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.TpClientPaymentId = this.props.tpClientPaymentId;
    selectedItem.TpClientInvoiceIds = this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.TpClientInvoiceId);
    selectedItem.InvoiceType = 'applied';
    TpClientPaymentService.RemovePayment(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment removed from Invoice(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('ATPCIA55', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.removePaymentFunction),
              label: 'Remove Payment(s)',
              tooltip: 'Remove Payment(s)',
              roleKey: 'tp_clientpayment_remove',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Remove the payment of all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    return `Remove the payment of the selected ${idList.length} Client Invoice(s)?`;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {!this.props.isReport && this.renderButtons()}
        <TabOfDataTable
          type={AppliedTpClientInvoiceItem}
          serviceFunction={TpClientInvoiceService.GetAppliedListBySearching}
          convertDBItemsFunction={TpClientInvoiceService.ConvertDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={TpClientPaymentTpClientInvoiceSearchParams}
          orderBy='TpClientInvoiceId'
          orderDirection='Desc'
          errorCode='ATPCIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          showSearchStrip={false}
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
